import React, { useEffect } from "react"
import Sugar from "sugar"
import "./InlineDropdown.css"

Sugar.extend()

const InlineDropdown = ({ options, selected, onSelect, className, style }) => {


  let main = React.createRef()
  let temp = React.createRef()

  useEffect(() => {
    temp.current.style.display = "inline-block"
    main.current.style.width = width(temp.current) + "px"
    temp.current.style.display = "none"
  })

  let onChange = event => {
    onSelect(event.target.value)
    event.target.blur()
  }

  return (
    <span className={ className } style={ style || {} }>
      <select ref={ main } onChange={ onChange } value={selected}>
        {options.map(({ title, value, disabled }, i) => (
          <option key={i} value={value} disabled={disabled} >
            {title}
          </option>
        ))}
      </select>

      <select ref={ temp } className="temp">
        <option>
          {options.find(x => x.value === selected).title}{" "}
          &#9662;
        </option>
      </select>

      <span className="dropdown">&#9662;</span>
    </span>
  )
}

export default InlineDropdown


const width = (el) =>
{
  return getComputedStyle(el, null).width.replace("px", "")
}
